import { mapGetters, mapActions } from 'vuex'
import Constants from '@/utils/Constants'

export default {
  name: 'NotFound',
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  computed: {
    ...mapGetters({
      getMeta: 'meta/get'
    }),
    pageTitle () {
      return 'Not Found'
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set'
    })
  }
}